import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { ChatMessageAttachments } from "web_myplann/Chat/Components/Messages/ChatMessageAttachments";
import { ChatMessageAvatar } from "web_myplann/Chat/Components/Messages/ChatMessageAvatar";
import { ChatMessageBubble } from "web_myplann/Chat/Components/Messages/ChatMessageBubble";
import { ChatMessageText } from "web_myplann/Chat/Components/Messages/ChatMessageText";
import { formatChatTime } from "web_myplann/Chat/Helpers/chatFormatting";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";

type Props = {
	message: ChatMessageView;
	advisorName: string;
	advisorPhoto?: string;
};

export const ChatRecipientMessage: FC<Props> = ({
	message,
	advisorName,
	advisorPhoto,
}) => {
	const theme = useTheme();
	const { message: messageTheme, recipient, timestamp } = theme.chat;
	const { content, attachments } = message;

	return (
		<ChatMessageBubble
			alignment="start"
			startAdornment={
				<ChatMessageAvatar name={advisorName} photo={advisorPhoto} />
			}
			status={message.status}
		>
			<ChatMessageAttachments
				attachments={attachments}
				fileStyle={{
					backgroundColor: recipient.background,
					color: recipient.attachmentColor,
					secondaryColor: recipient.attachmentSecondaryColor,
					boxShadow: theme.shadows[recipient.elevation],
				}}
			/>

			{content && (
				<Typography
					className="chat_bubble"
					variant="body2"
					color={recipient.textColor}
					px={messageTheme.paddingX}
					py={messageTheme.paddingY}
					lineHeight={messageTheme.lineHeight}
					bgcolor={recipient.background}
					boxShadow={theme.shadows[recipient.elevation]}
				>
					<ChatMessageText content={content} linkColor={recipient.linkColor} />
				</Typography>
			)}

			<Typography
				className="chat_group_tail"
				variant="hint"
				pl={timestamp.inset}
			>
				{formatChatTime(message.createdAt)}
			</Typography>
		</ChatMessageBubble>
	);
};
